import {
  Box,
  Container,
  Grid,
  useMediaQuery,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import Header, { navArray } from "./Header";
import { navLogo } from "./SmallComponents/Images";
import { FaPlus } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";
import { EarnedPoints, ExternalPoints, PointsBreakdown } from "../pages";
import { useContext } from "react";
import { AppContext, serverUrl, twitterPostLink } from "../utils";
import axios from "axios";
import { StyledButton } from "./SmallComponents/AppComponents";
import { useWeb3Modal } from "@web3modal/wagmi/react";

function SideDrawer({ children }) {
  const { open } = useWeb3Modal();
  const { account, userDatabaseId } = useContext(AppContext);
  const matches = useMediaQuery("(max-width:800px)");
  const { pathname } = useLocation();

  useEffect(() => {
    if (account && userDatabaseId) {
      (async () => {
        try {
          await axios.put(
            `${serverUrl}/add_user_wallet/${userDatabaseId}/${account}`
          );
        } catch (e) {
          console.log(e);
        }
      })();
    }
  }, [account, userDatabaseId]);

  return (
    <Box>
      <Container>
        <Box
          sx={{
            borderRadius: "30px",
            // border: "3px solid #ffffff",
            boxShadow: "0px 3px 22px 0px #ffffff",
            // border: "3px solid #000000",
            overflow: "hidden",
            my: 4,
            pb: { xs: 5, md: 10 },
            backgroundColor: "#292929",
          }}
        >
          <Grid container spacing={4}>
            <Grid
              item
              xs={12}
              sx={{
                backgroundColor: "#292929",
                borderBottom: "1px solid #ffffff",
              }}
            >
              <Header />
            </Grid>
            {/* {account ? ( */}
            <>
              {!matches && (
                <Grid item xs={12}>
                  <Box mx={4}>
                    {/* <Box
                        component={"img"}
                        alt=""
                        src={navLogo}
                        width="200px"
                      /> */}
                    <Typography
                      variant="h1"
                      sx={{
                        fontFamily: "Saira Semi Condensed",
                        fontSize: { xs: "28px", md: "38px" },
                        fontWeight: "700",
                        color: "#ffffff",
                      }}
                    >
                      BITGROK AI
                    </Typography>
                  </Box>
                </Grid>
              )}
              {!matches && (
                <Grid item xs={12} md={4}>
                  <Box
                    // bgcolor="#f2f0f0"
                    bgcolor="#292929"
                    display="flex"
                    flexDirection="column"
                    // minHeight="100vh"
                    px={3}
                    height="100%"
                    width="100%"
                    gap={3}
                  >
                    {navArray?.map(({ fillIcon, unfillIcon, text, link }) => (
                      <Link
                        key={text}
                        to={link}
                        style={{ textDecoration: "none" }}
                      >
                        <Box
                          key={text}
                          sx={{
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "center",
                            gap: 3,
                            cursor: "pointer",
                            mt: 2,
                          }}
                        >
                          <Box
                            component={"img"}
                            alt=""
                            src={pathname === link ? fillIcon : unfillIcon}
                            width="40px"
                          />
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontFamily: "Saira Semi Condensed",
                              letterSpacing: "1px",
                              fontWeight: "600",
                              fontSize: "22px",
                              color:
                                pathname === link
                                  ? pathname === "/points-details"
                                    ? "#8102FF"
                                    : "#A229D4"
                                  : "#ffffff",
                            }}
                          >
                            {text}
                          </Typography>
                        </Box>
                      </Link>
                    ))}
                    <Box mt={6} pl={4}>
                      <Button
                        href={twitterPostLink}
                        target="_blank"
                        startIcon={<FaPlus />}
                        sx={{
                          backgroundColor:
                            pathname === "/points-details"
                              ? "#1DA1F2"
                              : "#A229D4",
                          height: "50px",
                          width: "150px",
                          borderRadius: "20px",
                          fontFamily: "Saira Semi Condensed",
                          fontWeight: "600",
                          fontSize: "16px",
                          color: "#0A0A0A",
                          textTransform: "capitalize",
                          "&:hover": {
                            backgroundColor:
                              pathname === "/points-details"
                                ? "#1DA1F2"
                                : "#A229D4",
                          },
                        }}
                      >
                        Post
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} md={8}>
                <Box px={{ xs: 2, md: 3 }}>{children}</Box>
              </Grid>
              {pathname === "/points-details" && (
                <Grid item xs={12}>
                  <ExternalPoints />
                  <EarnedPoints />
                  <PointsBreakdown />
                </Grid>
              )}
            </>
            {/* ) : (
              <Grid item xs={12} md={12}>
                <Box height={"50vh"}>
                  <Typography
                    mt={5}
                    variant="h1"
                    sx={{
                      fontFamily: "Saira Semi Condensed",
                      fontWeight: 700,
                      fontSize: { xs: "22px", sm: "36px" },
                      lineHeight: "50px",
                      textAlign: { xs: "center" },
                      color: "#ffffff",
                      textTransform: "uppercase",
                    }}
                  >
                    Connect Wallet to go further
                  </Typography>
                  <Stack
                    sx={{
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 3,
                      display: { xs: "flex", md: "none" },
                    }}
                  >
                    <StyledButton
                      px={2}
                      width="160px"
                      onClick={async () => await open()}
                    >
                      Connect Wallet
                    </StyledButton>
                  </Stack>
                </Box>
              </Grid>
            )} */}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}

export default SideDrawer;
